import { required } from 'react-admin'

import config from './config'
import AdvancedReferenceInput from '../../components/AdvancedReferenceInput'

const OrganisationReferenceInput = (props) => {
  return (
    <AdvancedReferenceInput
      reference={config.name}
      source={config.options.referenceKey}
      sort={config.options.defaultSort}
      filter={config.options.defaultFilterValues}
      validate={required()}
      {...props}
    />
  )
}

export default OrganisationReferenceInput
